const actions = {
    GET_ORDERS_HISOTORY_LIST: "GET_ORDERS_HISOTORY_LIST"
}

const initialState = {
    orderHistory: [],
    filter: {
        pagesFilter: { pageCount: 1, currentPage: 1, maxItemsOnPage: 1 },
        modelFilter: {
            orderNumber: ""
        },
        sortFilter: {}
    }
};

export default function reducer(state, action) {
    state = state || initialState;

    switch (action.type) {
        case actions.GET_ORDERS_HISOTORY_LIST:
            {
                return {
                    ...state,
                    orderHistory: action.orderHistory.items,
                    filter: action.orderHistory.filter
                };
            }
        default:
            return state;
    }
};

export const updateOrderHistory = (orderHistory) => ({type: actions.GET_ORDERS_HISOTORY_LIST, orderHistory});
